import { getCompanyTypes } from "@services/licensingApi";
import { useQuery } from "@tanstack/react-query";

export const useCompanyTypes = (options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: ["companyTypes"],
    queryFn: getCompanyTypes,
    staleTime: Infinity,
    ...options,
  });
